import { render, staticRenderFns } from "./FeaturesCard.vue?vue&type=template&id=6f7309c4&scoped=true"
import script from "./FeaturesCard.vue?vue&type=script&lang=js"
export * from "./FeaturesCard.vue?vue&type=script&lang=js"
import style0 from "./FeaturesCard.vue?vue&type=style&index=0&id=6f7309c4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7309c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f7309c4')) {
      api.createRecord('6f7309c4', component.options)
    } else {
      api.reload('6f7309c4', component.options)
    }
    module.hot.accept("./FeaturesCard.vue?vue&type=template&id=6f7309c4&scoped=true", function () {
      api.rerender('6f7309c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Features/components/FeaturesCard.vue"
export default component.exports